import { Close } from '@myinterview/component-library';
import React from 'react';

interface IProps {
  onClick: () => void;
}

export const MinimizeButton:React.FC<IProps> = ({ onClick }) => (
  <div className="myinterview-widget-minimize" onClick={onClick} role="presentation">
    <Close />
  </div>
);
